import { useNavigate } from "react-router-dom";
import { FileSignature } from "lucide-react";
import { useContracts, useContractActions, CONTRACT_STATUS_LABEL, CONTRACT_STATUS_VARIANT } from "./api";
import { dateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

/** Bloc « Contrat » d'une commande : contrat en cours / signé, avenants, création. */
export function OrderContractSection({ orderId, clientId, cancelled }: { orderId: string; clientId: string; cancelled: boolean }) {
  const nav = useNavigate();
  const { data: contracts } = useContracts({ orderId });
  const actions = useContractActions();
  const main = contracts?.find((c) => c.kind === "contract" && !["cancelled", "declined", "expired"].includes(c.status));
  return (
    <section className="glass mt-6 rounded-2xl p-5">
      <div className="mb-2 flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">Contrat</h3>
        {!main && !cancelled && <Button size="sm" onClick={() => actions.create.mutate({ clientId, orderId }, { onSuccess: (id) => nav(`/contrats/${id}`) })} disabled={actions.create.isPending}><FileSignature className="mr-2 h-4 w-4" />Créer le contrat</Button>}
      </div>
      {!contracts ? <p className="text-sm text-muted-foreground">Chargement…</p> : contracts.length === 0 ? <p className="text-sm text-muted-foreground">Aucun contrat. Le contrat reprend les lignes, prix et conditions de la commande ; sa signature (avec l'acompte) confirme la commande.</p> : (
        <ul className="divide-y divide-border/60 text-sm">
          {contracts.map((c) => (
            <li key={c.id} className="flex flex-wrap items-center justify-between gap-2 py-2">
              <button className="text-left hover:underline" onClick={() => nav(`/contrats/${c.id}`)}><span className="font-mono text-xs">{c.number ?? "brouillon"}</span> · {c.title}</button>
              <span className="flex items-center gap-2 text-muted-foreground">{c.signed_at ? `signé le ${dateTime(c.signed_at)}` : c.sent_at ? `envoyé le ${dateTime(c.sent_at)}` : ""}<Badge variant={CONTRACT_STATUS_VARIANT[c.status]}>{CONTRACT_STATUS_LABEL[c.status]}</Badge></span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
